import Util from "@/helper/Utility.js";
export function RegisterModel() {
    this.storeId = '';
    this.storeName = '';
    this.firstname = '';
    this.lastname = '';
    this.email = '';
    this.contactNumber = '';
    this.username = '';
    this.password = '';
    this.confirmPassword = '';
    this.storeType = [];
    this.brandIds = '';
    this.refcode = '';
    this.otp = '';
    this.termandcondition = 1;
    this.dataprivacy = 1;
    this.marketingOption = 1;
    this.mktoption_sms = false,
    this.mktoption_email = false,
    this.customInfo = null,

    this.getParams = function() {
        var params = {
            // StoreID: this.storeId,
            // StoreName: this.storeName,
            firstname: this.firstname,
            lastname: this.lastname,
            contact_number: this.contactNumber,
            email: this.email,
            username: this.username,
            password: this.password,
            confirmpassword: this.confirmPassword,
            refcode: this.refcode,
            otp: this.otp,
            custom_info: this.customInfo,

            termandcondition: this.termandcondition ? this.termandcondition : 0,
            dataprivacy: this.dataprivacy ? this.dataprivacy : 0,
            marketingOption: this.marketingOption ? this.marketingOption : 0,
            mktoption_sms: this.mktoption_sms,
            mktoption_email: this.mktoption_email,

            app_id: 'null'
        };

        return Util.cleanObjectEmptyStr(params);
    };
}
export function StoreTypeList(){
    this.storeTypeList = [
        // {value: false , textTH: 'ดรอปชิป' , textEN: 'Dropship' , name: 'test1' , id:'1'},
        // {value: false , textTH: 'ร้านค้าปลีก' ,textEN: 'Retail' , name: 'test2' , id:'2'},
        // {value: false , textTH: 'ร้านค้าส่ง' , textEN: 'Wholesale' , name: 'test3' , id:'3'},
        // {value: false , textTH: 'ร้านอาหาร/เครื่องดื่ม' ,textEN: 'Restaurant/Beverage',  name: 'test4' , id:'4'},
        // {value: false , textTH: 'อื่นๆ' ,textEN: 'Other', name: 'test5' , id:'5'},
        {value: false , textTH: 'ประเภทร้านค้า' , textEN: 'Shop' , name: 'test1' , id:'1'},
        {value: false , textTH: 'ซูเปอร์มาร์เก็ต' ,textEN: 'Supermarket' , name: 'test2' , id:'2'},
        {value: false , textTH: 'ร้านค้าปลีกเฉพาะอย่าง' , textEN: 'Specialty Retail Stores' , name: 'test3' , id:'3'},
        {value: false , textTH: 'ห้างสรรพสินค้า' ,textEN: 'Mall',  name: 'test4' , id:'4'},
        {value: false , textTH: 'ร้านสะดวกซื้อ' ,textEN: 'Convenience Store', name: 'test5' , id:'5'},
        {value: false , textTH: 'ร้านค้าปลีกขนาดเล็ก' ,textEN: 'Small Retail Store', name: 'test6' , id:'6'},
    ]
    return this.storeTypeList;
}
